/* eslint-disable @typescript-eslint/no-unused-vars */
import { Button, HStack, Image, Text, VStack } from '@chakra-ui/react'

import { HeaderLogo } from 'components/HeaderLogo'
import { VehiclePlateInfo } from 'components/VehiclePlateInfo'

import {  TertiaryProps } from '../types'

export const TertiaryVariant: React.FC<TertiaryProps> = ({
   title, vehicle,message,
   closeAcceptPress,
   closeGoBackPress,
   messageAlignmentLeft = false,
   customFillIcon,
   primaryButton = false,
   primaryTextButton = 'Entendido',
   secondaryButton = false,
   secondaryTextButton,
   iconType = 'info',
   showClose = false,
   primaryButtonProps
   }) => {


  return (
    <VStack
      w={'full'}
      h={'full'}
      spacing={28}
      bgColor={'transparent'}
  >
      <VStack
        w="full"
        alignItems="center"
        spacing={4}
        bgColor={'transparent'}
      >
        <HeaderLogo />
        <VStack alignItems="center">
          {title && <Text fontWeight={'bold'} variant="LG">{title}</Text>}
          {message && <Text variant={{ base: 'XS', md: 'MD' }}>{message}</Text>}
        </VStack>
        <Image
          src={`${vehicle?.mainImageUrl}`}
          maxH={'200px'}
          maxW={'60%'}
          alt={vehicle?.plateNumber}
        />
        <HStack alignItems="center" justifyContent="center">
          <VehiclePlateInfo
            vehicle={vehicle}
            flex={0}
            direction="row"
          />
        </HStack>
      </VStack>
        { primaryButton && (
        <Button
          onClick={closeAcceptPress}
          w="full"
          variant="primary"
          {...primaryButtonProps}
        >
          {primaryTextButton}
        </Button>
        )}
    </VStack>
  )
}
